// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const DeviationOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M2 6h20M2 18h20","stroke-width":"2","stroke":"currentColor"}},{"tag":"path","attrs":{"d":"M12 6v12","stroke-dasharray":"2 2","stroke":"currentColor"}}]},"name":"deviation","theme":"outlined"};

const DeviationOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={DeviationOutlinedSvg} />;
  DeviationOutlined.displayName = 'DeviationOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(DeviationOutlined);
